import React, { useState, Suspense, useEffect, lazy } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { saveCustomerInfo } from '../store/actions/AuthAction';
import { handleLogoutCookie } from './utils/cookies';
import LoadingStore from './shared/LoadingStore';
import { getListLink } from './shared/MenuPermission/Controllers/menuApis';
import ConfigureRewardPoints from './components/RewardPoints/Views/ConfigureRewardPoints';
import ConfigureUseRewardPoints from './components/RewardPoints/Views/ConfigureUseRewardPoints';
import PointRedemptionPolicyList from './components/PointRedemptionPolicy/Views/PointRedemptionPolicyList';
import PointRedemptionPolicyCreate from './components/PointRedemptionPolicy/Views/PointRedemptionPolicyCreate';
import PointRedemptionPolicyEdit from './components/PointRedemptionPolicy/Views/PointRedemptionPolicyEdit';
import ElementCheckPermissionWrapper from './utils/ElementCheckPermissionWrapper';

const Store = lazy(() => import('./components/Store/Views/Store'));
const Product = lazy(() => import('./components/Product/Views/Product'));
const Category = lazy(() => import('./components/Category/Views/Category'));
const Customer = lazy(() => import('./components/Customer/Views/Customer'));
const ProviderList = lazy(() => import('./components/ProviderList/Views/ProviderList'));
const BatchExpiryDateReport = lazy(() =>
    import('./components/Reports/BatchExpiryDateReport/Views/BatchExpiryDateReport')
); // BAO CAO SAN PHAM THEO LO VA HSD
const Unit = lazy(() => import('./components/Product/Views/UnitManager/Views/ListUnit')); // UNIT
const Shipment = lazy(() => import('./components/Product/Views/ShipmentManager/Views/ShipmentList')); // Quản lý Lô
const CashBookRetail = lazy(() => import('./components/CashBookRetail/View/CashBookRetailList'));
const ConfigTimeDelivery = lazy(() => import('./components/SystemConfig/TimeDelivery/Views/ListTimeDelivery')); // Cấu hình thời gian
const ConfigFees = lazy(() => import('./components/SystemConfig/Fees/Views/ListFees')); // Cấu hình thời gian
const AccountConfiguration = lazy(() => import('./components/AccountConfiguration/Views/AccountConfiguration')); // Cấu hình tài khoản
const ResourceManagement = lazy(() => import('./components/ResourceManagement/Views/ResourceManagement'));
const NotFound = lazy(() => import('./shared/NotFound')); // NotFound
const HomePage = lazy(() => import('./shared/HomePage')); // Trang chu
const ResourceManagementPayment = lazy(() => import('./components/ResourceManagement/Views/ResourceManagementPayment'));
// Xuất hủy
const CancellationTicketList = lazy(() => import('./components/CancellationTicket/Views/CancellationTicketList')); // danh sách
const CreateCancellationTicket = lazy(() => import('./components/CancellationTicket/Views/CreateCancellationTicket')); // thêm mới
const EditCancellationTicket = lazy(() => import('./components/CancellationTicket/Views/EditCancellationTicket')); // chỉnh sửa
// điều chỉnh
const AdjustmentTicketList = lazy(() => import('./components/AdjustmentTicket/Views/AdjustmentTicketList')); // danh sách
const AdjustmentTicketCreate = lazy(() => import('./components/AdjustmentTicket/Views/AdjustmentTicketCreate')); // thêm mới
const AdjustmentTicketUpdate = lazy(() => import('./components/AdjustmentTicket/Views/AdjustmentTicketEdit')); // chỉnh sửa
// quan ly cong ty
const CompanyManagementList = lazy(() => import('./components/CompanyManagement/Views/CompanyManagementList')); // danh sách
// cấu hình chế biến
const ProcessingConfigurationList = lazy(() =>
    import('./components/ProcessingConfiguration/Views/ProcessingConfigurationList')
); // danh sách
const Inventory = lazy(() => import('./components/Inventory/Views/InventoryList'));
const InventoryCreate = lazy(() => import('./components/Inventory/Views/InventoryCreate'));
const InventoryUpdate = lazy(() => import('./components/Inventory/Views/InventoryEdit'));
// Nhập hàng
const GoodReceived = lazy(() => import('./components/MerchandiseReceived/Views/MerchandiseReceivedList'));
const GoodReceivedCreate = lazy(() => import('./components/MerchandiseReceived/Views/MerchandiseReceivedCreate'));
const GoodReceivedEdit = lazy(() => import('./components/MerchandiseReceived/Views/MerchandiseReceivedEdit'));
//  Chính sách bán hàng
const SaleProgram = lazy(() => import('./components/SaleProgram/Views/SaleProgram'));
const AddSaleProgram = lazy(() => import('./components/SaleProgram/Views/NewProgram'));
const EditSaleProgram = lazy(() => import('./components/SaleProgram/Views/UpdateProgram'));
// Chính sách tích điểm
const AccumulatePolicy = lazy(() => import('./components/AccumulatePolicy/views/AccumulatePolicy'));
const AddAccumulatePolicy = lazy(() => import('./components/AccumulatePolicy/views/create/AccumulatePolicyCreate'));
const EditAccumulatePolicy = lazy(() => import('./components/AccumulatePolicy/views/update/index'));

// Chương trình loyalty
const LoyaltyProgram = lazy(() => import('./components/LoyaltyProgram/Views/LoyaltyProgramList'));
const AddLoyaltyProgram = lazy(() => import('./components/LoyaltyProgram/Views/LoyaltyProgramCreate'));
const EditLoyaltyProgram = lazy(() => import('./components/LoyaltyProgram/Views/LoyaltyProgramEdit'));

// Chuyển Hàng
const ShippingManagement = lazy(() => import('./components/ShippingManagement/Views/ShippingManagementList'));
const ShippingManagementCreate = lazy(() => import('./components/ShippingManagement/Views/Create'));
const ShippingManagementEdit = lazy(() => import('./components/ShippingManagement/Views/Edit'));
// Trả hàng nhập
const MerchandiseReturned = lazy(() => import('./components/MerchandiseReturned/Views/MerchandiseReturnedList'));
const MerchandiseReturnedCreate = lazy(() =>
    import('./components/MerchandiseReturned/Views/MerchandiseReturnedCreate')
);
const MerchandiseReturnedEdit = lazy(() => import('./components/MerchandiseReturned/Views/MerchandiseReturnedEdit'));
// Bán hàng
const RetailManageCreate = lazy(() => import('./components/RetailManage/SaleManager/Views/create'));

const CustomerOrder = lazy(() => import('./components/RetailManage/SaleManager/Views/SaleManager/CustomerOrder'));

// Báo cáo hàng nhập theo nhà cung cấp
const ReportImport = lazy(() => import('./components/Reports/ReportImport/Views/ReportImport'));
// pha chế
const Bartender = lazy(() => import('./components/RetailManage/BatenderManager/Views/Bartender'));

// Báo cáo xuất hủy
const ReportCancelExportation = lazy(() =>
    import('./components/Reports/CancelExportationReport/Views/CancelExportationReport')
);

// Báo cáo phế phẩm sơ chế
const ReportProductRegime = lazy(() => import('./components/Reports/ReportProductRegime/Views/ReportProductRegime'));

// báo cáo top hàng hóa
const ReportTopProduct = lazy(() => import('./components/Reports/ReportTopProducts/Views/ReportTopProduct'));

// báo cáo nhóm lựa chọn
const ReportTopping = lazy(() => import('./components/Reports/ReportTopping/Views/ListToppingReport'));

// danh sách đơn hàng
const ListOder = lazy(() => import('./components/RetailManage/SaleManager/Views/list'));

// cấu hình sơ chế
const PreliminaryConfigurationList = lazy(() =>
    import('./components/PreliminaryConfiguration/Views/PreliminaryConfigurationList')
);

// phieu xuat so che
const PreliminaryExportationList = lazy(() =>
    import('./components/PreliminaryExportation/Views/PreliminaryExportationList')
);
const PreliminaryExportationCreate = lazy(() =>
    import('./components/PreliminaryExportation/Views/PreliminaryExportationCreate')
);
const PreliminaryExportationEdit = lazy(() =>
    import('./components/PreliminaryExportation/Views/PreliminaryExportationEdit')
);

// Trả hàng bán
const ReturnSales = lazy(() => import('./components/RetailManage/ReturnSalesManager/ReturnSalesManager'));

// Cấu hình chính sách trả hàng bán
const ConfigPolicyReturnSale = lazy(() => import('./components/SystemConfig/PolicyReturnSales'));

// xuat che bien
const ProcessingExportationCreate = lazy(() =>
    import('./components/ProcessingExportation/Views/ProcessingExportationCreate')
);
const ProcessingExportationList = lazy(() =>
    import('./components/ProcessingExportation/Views/ProcessingExportationList')
);
const ProcessingExportationEdit = lazy(() =>
    import('./components/ProcessingExportation/Views/ProcessingExportationEdit')
);

// Báo cáo doanh thu theo sản phẩm
const RevenueReport = lazy(() => import('./components/Reports/RevenueReport/Views/ListRevenueReport'));

// Báo cáo doanh thu theo ngày
const RevenueByDayReport = lazy(() => import('./components/Reports/RevenueByDayReport/Views/ListRevenueReport'));

// Báo cáo xuất nhập tồn
const InventoryReport = lazy(() => import('./components/Reports/InventoryReport/Views/ListRevenueReport'));

// Báo cáo chương trình bán hàng
const SaleProgramReport = lazy(() => import('./components/Reports/SaleProgramReport/View/List'));

// Báo cáo hiệu quả chương trình Loyalty
const LoyaltyPerformanceReport = lazy(() => import('./components/LoyaltyPerformanceReport/Views/LoyaltyPerformanceReport'));

// Báo cáo bán hàng theo khách hàng
const SalesByCustomer = lazy(() => import('./components/Reports/SalesByCustomer/Views/SalesByCustomer'));

// Báo cáo hàng bán theo khách hàng
const merchandiseByCustomer = lazy(() =>
    import('./components/Reports/MerchandiseByCustomer/Views/MerchandiseByCustomer')
);

// Báo cáo tổng hợp cuối ngày
const SynthesisEndDay = lazy(() => import('./components/Reports/SynthesisEndDay/Views/SynthesisEndDay'));

// Intem sản phẩm
const CreatePrintTempProduct = lazy(() => import('./components/RetailManage/SaleManager/Views/CreateTempProduct'));

// Báo cáo nhập hàng theo nhà cung cấp
const ImportMerchanProvider = lazy(() => import('./components/Reports/ImportProvider/Views'));

// Nhóm khách hàng
const GroupCustomer = lazy(() => import('./components/GroupCustomer/Views/List'));

// Nhóm khách hàng
const RequestGoodsReceipt = lazy(() => import('./components/WareHouse/RequestGoodsReceipt/Views/List'));
const CreateRequestGoodsReceipt = lazy(() => import('./components/WareHouse/RequestGoodsReceipt/Views/Create'));
const UpdateRequestGoodsReceipt = lazy(() => import('./components/WareHouse/RequestGoodsReceipt/Views/Edit'));

// Yêu cầu xuất hóa đơn
const RequestExportInvoice = lazy(() => import('./components/RequestExportInvoice/InvoiceExportConfig/Views/InvoiceExportConfig'));
// const CreateRequestExportInvoice = lazy(() => import('./components/RequestExportInvoice/SaleManager/Views/create'));

// Tiến trình chạy giá vốn trung bình
const AverageCapitalPriceList = lazy(() => import('./components/AverageCapitalPrice/Views/List'));

//tem nguyên liệu
const ListIngredient = lazy(() => import('./components/Product/Views/Ingredient/Views/ListIngredient'));

//thực đơn
const ListMenu = lazy(() => import('./components/Product/Views/Menu/Views/ListMenu'));
const AddMenu = lazy(() => import('./components/Product/Views/Menu/Views/AddMenu'));
const EditMenu = lazy(() => import('./components/Product/Views/Menu/Views/EditMenu'));

//thực đơn mini app
const ListMenuMiniApp = lazy(() => import('./components/Product/Views/MenuMiniApp/Views/ListMenu'));

//nhóm lựa chọn
const ListGroupAddition = lazy(() => import('./components/Product/Views/GroupAddition/Views/ListGroupAddition'));
const AddGroupAddition = lazy(() => import('./components/Product/Views/GroupAddition/Views/AddGroupAddition'));
const EditGroupAddition = lazy(() => import('./components/Product/Views/GroupAddition/Views/EditGroupAddition'));

//nhóm lựa chọn mini app
const ListGroupAdditionMiniApp = lazy(() => import('./components/Product/Views/GroupAdditionMiniApp/Views/ListGroupAdditionMiniApp'));
const EditGroupAdditionMiniApp = lazy(() => import('./components/Product/Views/GroupAdditionMiniApp/Views/EditGroupAdditionMiniApp'));

//màn hình phụ
const SecondaryConfig = lazy(() => import('./components/SecondaryScreenConfig/Views/SecondaryScreenConfig'));

//Cấu hình huỷ đơn hàng 
const ListCancelOrderConfig = lazy(() => import('./components/CancelOrderConfig/View/List'));

// Báo cáo doanh thu
const ReportRevenue = lazy(() => import('./components/Reports/ReportRevenue/Views/list'));

// Báo cáo phát sinh - sử dụng điểm
const PointUsageReport = lazy(() => import('./components/Reports/ReportPointUsage/Views/ReportPointUsage'));

//Báo cáo tổng quan
const DashboardReport = lazy(() => import('./components/Reports/ReportDashoard/Views/Dashboard'));

const ConfigPrinter = lazy(() => import('./components/ConfigPrinter/ConfigPrinter'));

const ListCustomerPoint = lazy(() => import('./components/CustomerPoint/Views/ListCustomerPoint'));
const ListCustomerPointDetail = lazy(() => import('./components/CustomerPoint/Views/ListCustomerPointDetail'));

const Test = lazy(() => import('../app/utils/Hooks/__test__'));

function AppRoutes(props) {
    let history = useHistory();
    const [listLink, setListLink] = useState([]);
    const header = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
        Authorization: props.token,
    };

    const handleGetListLink = async () => {
        try {
            const result = await getListLink(header);
            if (result.status === 200) {
                setListLink(result.data);
            } else {
                if (result.status !== 401) {
                    toast.error(result.message);
                    history.push('/notFound');
                }
            }
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    };

    useEffect(() => {
        if (props.token) {
            handleGetListLink();
        }
    }, [props.token]);

    return (
        <Suspense fallback={<LoadingStore />}>
            <Switch>
                <Route exact path='/notFound' component={NotFound} />
                {listLink.includes('/shipment-manger') && <Route exact path='/shipment-manger' component={Shipment} />}
                {listLink.includes('/products') && <Route exact path='/products' component={Product} />}
                {listLink.includes('/stores') && <Route exact path='/stores' component={Store} />}
                {listLink.includes('/category') && <Route exact path='/category' component={Category} />}
                {listLink.includes('/providers') && <Route exact path='/providers' component={ProviderList} />}
                {listLink.includes('/batch-expiry-date-report') && (
                    <Route exact path='/batch-expiry-date-report' component={BatchExpiryDateReport} />
                )}
                {listLink.includes('/cashBookRetail') && (
                    <Route exact path='/cashBookRetail' component={CashBookRetail} />
                )}

                {listLink.includes('/resource-management') && (
                    <Route exact path='/resource-management' component={ResourceManagement} />
                )}
                {listLink.includes('/resource-management-payment') && (
                    <Route exact path='/resource-management-payment' component={ResourceManagementPayment} />
                )}
                {listLink.includes('/account-configuration') && (
                    <Route exact path='/account-configuration' component={AccountConfiguration} />
                )}
                {listLink.includes('/cancellation-ticket') && (
                    <Route exact path='/cancellation-ticket' component={CancellationTicketList} />
                )}
                {listLink.includes('/cancellation-ticket-create') && (
                    <Route exact path='/cancellation-ticket-create' component={CreateCancellationTicket} />
                )}
                {listLink.includes('/cancellation-ticket-update') && (
                    <Route exact path='/cancellation-ticket-update' component={EditCancellationTicket} />
                )}
                {listLink.includes('/adjustment-ticket') && (
                    <Route exact path='/adjustment-ticket' component={AdjustmentTicketList} />
                )}
                {listLink.includes('/adjustment-ticket-create') && (
                    <Route exact path='/adjustment-ticket-create' component={AdjustmentTicketCreate} />
                )}
                {listLink.includes('/adjustment-ticket-update') && (
                    <Route exact path='/adjustment-ticket-update' component={AdjustmentTicketUpdate} />
                )}
                {listLink.includes('/company-management') && (
                    <Route exact path='/company-management' component={CompanyManagementList} />
                )}
                {listLink.includes('/inventory') && <Route exact path='/inventory' component={Inventory} />}
                {listLink.includes('/inventory-create') && (
                    <Route exact path='/inventory-create' component={InventoryCreate} />
                )}
                {listLink.includes('/inventory-update') && (
                    <Route exact path='/inventory-update' component={InventoryUpdate} />
                )}
                {/* Quản lý lô hàng */}
                {listLink.includes('/shipment-manger') && <Route exact path='/shipment-manger' component={Shipment} />}
                {/* Danh mục sản phẩm */}
                {listLink.includes('/category') && <Route exact path='/category' component={Category} />}
                {/* Khách hàng */}
                {listLink.includes('/customers') && <Route exact path='/customers' component={Customer} />}
                {/* Nhà cung cấp */}
                {listLink.includes('/providers') && <Route exact path='/providers' component={ProviderList} />}
                {/* Chi nhánh */}
                {listLink.includes('/stores') && <Route exact path='/stores' component={Store} />}
                {/* Đơn vị tính */}
                {listLink.includes('/unit-manger') && <Route exact path='/unit-manger' component={Unit} />}
                {/* Sản phẩm */}
                {listLink.includes('/products') && <Route exact path='/products' component={Product} />}
                {/* BÁO CÁO SẢN PHẨM THEO LÔ VÀ HSD */}
                {listLink.includes('/batch-expiry-date-report') && (
                    <Route exact path='/batch-expiry-date-report' component={BatchExpiryDateReport} />
                )}
                {/* Sổ quỹ retail */}
                {listLink.includes('/') && <Route exact path='/cashBookRetail' component={CashBookRetail} />}
                {/* Cấu hình hệ thống */}
                {listLink.includes('/config-time-delivery') && (
                    <Route exact path='/config-time-delivery' component={ConfigTimeDelivery} />
                )}
                {listLink.includes('/config-fees') && <Route exact path='/config-fees' component={ConfigFees} />}
                {/* Nhập hàng */}
                {listLink.includes('/goodReceived') && <Route exact path='/goodReceived' component={GoodReceived} />}
                {listLink.includes('/goodReceivedCreate') && (
                    <Route exact path='/goodReceivedCreate' component={GoodReceivedCreate} />
                )}
                {listLink.includes('/goodReceivedEdit') && (
                    <Route exact path='/goodReceivedEdit' component={GoodReceivedEdit} />
                )}
                {/* Chuyển hàng */}
                {listLink.includes('/shipping-management') && (
                    <Route exact path='/shipping-management' component={ShippingManagement} />
                )}
                {listLink.includes('/shipping-management-create') && (
                    <Route path='/shipping-management-create' component={ShippingManagementCreate} />
                )}
                {listLink.includes('/shipping-management-edit') && (
                    <Route path='/shipping-management-edit' component={ShippingManagementEdit} />
                )}
                {/* Trả hàng nhập */}
                {listLink.includes('/merchandiseReturned') && (
                    <Route exact path='/merchandiseReturned' component={MerchandiseReturned} />
                )}
                {listLink.includes('/merchandiseReturnedCreate') && (
                    <Route path='/merchandiseReturnedCreate' component={MerchandiseReturnedCreate} />
                )}
                {listLink.includes('/merchandiseReturnedEdit') && (
                    <Route path='/merchandiseReturnedEdit' component={MerchandiseReturnedEdit} />
                )}
                {/* Chính sách bán hàng */}
                {listLink.includes('/sale-program') && <Route exact path='/sale-program' component={SaleProgram} />}
                {listLink.includes('/sale-program/add') && (
                    <Route path='/sale-program/add' component={AddSaleProgram} />
                )}
                {listLink.includes('/sale-program/edit') && (
                    <Route path='/sale-program/edit' component={EditSaleProgram} />
                )}
                {/* Bán Hàng */}
                {listLink.includes('/manage-retail/list') && (
                    <Route path='/manage-retail/list' component={EditSaleProgram} />
                )}
                {/* pha chế */}
                {listLink.includes('/bartender') && <Route path='/bartender' component={Bartender} />}

                {/* cấu hình chế biến */}
                {listLink.includes('/process-config') && (
                    <Route path='/process-config' component={ProcessingConfigurationList} />
                )}

                {/* báo cáo hàng nhập theo nhà cung cấp */}
                {listLink.includes('/report-import-merchandise') && (
                    <Route path='/report-import-merchandise' component={ReportImport} />
                )}

                {/* báo cáo xuất hủy */}
                {listLink.includes('/report-cancel-exportation') && (
                    <Route path='/report-cancel-exportation' component={ReportCancelExportation} />
                )}
                {listLink.includes('/preliminary-configuration') && (
                    <Route path='/preliminary-configuration' component={PreliminaryConfigurationList} />
                )}

                {/* báo cáo phế phẩm sơ chế */}
                {listLink.includes('/report-product-regime') && (
                    <Route path='/report-product-regime' component={ReportProductRegime} />
                )}

                {/* báo cáo top hàng hóa */}
                {listLink.includes('/top-product') && <Route path='/top-product' component={ReportTopProduct} />}

                {/* Danh sách đơn hàng */}
                {listLink.includes('/listOrder') && <Route path='/listOrder' component={ListOder} exact />}
                {listLink.includes('/manage-retail/create') && (
                    <Route path='/manage-retail/create' component={RetailManageCreate} />
                )}

                {/* phieu xuat so che */}
                {listLink.includes('/preliminary-exportation') && (
                    <Route path='/preliminary-exportation' component={PreliminaryExportationList} />
                )}
                {listLink.includes('/preliminary-exportation-create') && (
                    <Route path='/preliminary-exportation-create' component={PreliminaryExportationCreate} />
                )}
                {listLink.includes('/preliminary-exportation-edit') && (
                    <Route path='/preliminary-exportation-edit' component={PreliminaryExportationEdit} />
                )}

                {listLink.includes('/policy-return-sales') && (
                    <Route path='/policy-return-sales' component={ConfigPolicyReturnSale} />
                )}

                {/* phieu xuat che bien */}
                {listLink.includes('/process-exportation') && (
                    <Route path='/process-exportation' component={ProcessingExportationList} />
                )}
                {listLink.includes('/process-exportation-create') && (
                    <Route path='/process-exportation-create' component={ProcessingExportationCreate} />
                )}
                {listLink.includes('/process-exportation-edit') && (
                    <Route path='/process-exportation-edit' component={ProcessingExportationEdit} />
                )}

                {/* Báo cáo doanh thu */}
                {listLink.includes('/revenue-report') && (
                    <Route exact path='/revenue-report' component={RevenueReport} />
                )}
                {listLink.includes('/revenue-report-day') && (
                    <Route exact path='/revenue-report-day' component={RevenueByDayReport} />
                )}

                {listLink.includes('/topping-report') && (
                    <Route exact path='/topping-report' component={ReportTopping} />
                )}

                {/* Báo cáo xuất nhập tồn */}
                {listLink.includes('/inventory-report') && (
                    <Route exact path='/inventory-report' component={InventoryReport} />
                )}

                {/* Trả hàng bán */}
                {listLink.includes('/return-sales') && <Route path='/return-sales' component={ReturnSales} />}

                {listLink.includes('/sale-programs-report') && (
                    <Route path='/sale-programs-report' component={SaleProgramReport} />
                )}

                {/* Báo cáo hiệu quả chương trình Loyalty */}
                {listLink.includes('/loyalty-performance-report') && (
                    <Route exact path='/loyalty-performance-report' component={LoyaltyPerformanceReport} />
                )}

                {/* Bán hàng theo khách hàng */}
                {listLink.includes('/sales-by-customer') && (
                    <Route path='/sales-by-customer' component={SalesByCustomer} />
                )}
                {/* Hàng bán theo khách hàng */}
                {listLink.includes('/merchandise-by-customer') && (
                    <Route path='/merchandise-by-customer' component={merchandiseByCustomer} />
                )}
                {/* Báo cáo tổng hợp cuối ngày */}
                {listLink.includes('/synthesis-end-day') && (
                    <Route path='/synthesis-end-day' component={SynthesisEndDay} />
                )}

                {listLink.includes('/listOrder/create-temp-product') && (
                    <Route path='/listOrder/create-temp-product' component={CreatePrintTempProduct} exact />
                )}

                {/* Báo cáo nhập hàng theo nhà cung cấp */}
                {listLink.includes('/report-import-provider') && (
                    <Route path='/report-import-provider' component={ImportMerchanProvider} exact />
                )}

                {/* Nhóm khách hàng */}
                {listLink.includes('/group-customer') && (
                    <Route path='/group-customer' component={GroupCustomer} exact />
                )}

                {/* Kho hàng */}
                {/* + Phiếu yêu cầu nhập hàng */}
                {listLink.includes('/request-good-receipt') && (
                    <Route path='/request-good-receipt' component={RequestGoodsReceipt} exact />
                )}
                {listLink.includes('/request-good-receipt/create') && (
                    <Route path='/request-good-receipt/create' component={CreateRequestGoodsReceipt} exact />
                )}
                {listLink.includes('/request-good-receipt/update') && (
                    <Route path='/request-good-receipt/update' component={UpdateRequestGoodsReceipt} exact />
                )}

                {/* <Route path='/request-export-invoice/create' component={CreateRequestExportInvoice} exact /> */}
                <Route path='/request-export-invoice' component={RequestExportInvoice} exact />

                {/* Tiến trình chạy giá vốn trung bình */}
                {listLink.includes('/average-capital-price') && (
                    <Route path='/average-capital-price' component={AverageCapitalPriceList} exact />
                )}
                {/* Điểm thưởng */}
                {listLink.includes('/reward-points') && (
                    <Route path='/reward-points' component={ConfigureRewardPoints} exact />
                )}
                {/* Trang danh sách chính sách đổi điểm */}
                {listLink.includes('/point-exchange-policy') && (
                    <Route
                        path='/point-exchange-policy'
                        exact
                        render={() => (
                            <ElementCheckPermissionWrapper>
                                <PointRedemptionPolicyList />
                            </ElementCheckPermissionWrapper>
                        )}
                    />
                )}
                {listLink.includes('/point-exchange-policy') && (
                    <Route
                        path='/point-exchange-policy/create'

                        render={() => (
                            <ElementCheckPermissionWrapper>
                                <PointRedemptionPolicyCreate />
                            </ElementCheckPermissionWrapper>
                        )}
                    />
                )}
                {listLink.includes('/point-exchange-policy') && (
                    <Route
                        path='/point-exchange-policy/update'

                        render={() => (
                            <ElementCheckPermissionWrapper>
                                <PointRedemptionPolicyEdit />
                            </ElementCheckPermissionWrapper>
                        )}
                    />
                )}

                {/* tem nguyên liệu */}
                {listLink.includes('/materials') && <Route path='/materials' component={ListIngredient} />}

                {/* thực đơn */}
                {listLink.includes('/menu') && <Route path='/menu' component={ListMenu} />}
                {listLink.includes('/menu-create') && <Route path='/menu-create' component={AddMenu} />}
                {listLink.includes('/menu-edit') && <Route path="/menu-edit" component={EditMenu} />}

                {/* thực đơn mini app */}
                {listLink.includes('/menu-mini-app') && <Route path='/menu-mini-app' component={ListMenuMiniApp} />}

                {/* nhóm lựa chọn */}
                {listLink.includes('/attribute-group') && <Route path='/attribute-group' component={ListGroupAddition} />}
                {listLink.includes('/attribute-group-create') && <Route path='/attribute-group-create' component={AddGroupAddition} />}
                {listLink.includes('/attribute-group-edit') && <Route path="/attribute-group-edit" component={EditGroupAddition} />}

                {/* nhóm lựa chọn mini app */}
                {listLink.includes('/attribute-group-mini-app') && <Route path='/attribute-group-mini-app' component={ListGroupAdditionMiniApp} exact />}
                {listLink.includes('/attribute-group-mini-app/edit') && <Route path="/attribute-group-mini-app/edit" component={EditGroupAdditionMiniApp} />}

                {/* màn hình phụ */}
                {listLink.includes('/ads-campaign') && <Route path='/ads-campaign' component={SecondaryConfig} />}

                {/* Cấu hình huỷ tem */}
                {listLink.includes('/cancel-order-config') && (
                    <Route path='/cancel-order-config' component={ListCancelOrderConfig} exact />
                )}

                {/* Cấu hình xuất hoá đơn */}
                {listLink.includes('/revenue') && (
                    <Route path='/revenue' component={ReportRevenue} exact />
                )}

                {listLink.includes('/customer-point') && (
                    <Route path='/customer-point' component={ListCustomerPoint} exact />
                )}
                {listLink.includes('/customer-point-detail') && (
                    <Route path='/customer-point-detail' component={ListCustomerPointDetail} exact />
                )}

                {/* Test */}
                <Route path='/Test' component={Test} />
                <Route path="/customer-order" component={CustomerOrder} />
                <Route path="/config-printer" component={ConfigPrinter} />
                {/* Chính sách tích điểm */}
                {listLink.includes('/accumulate-policy') && <Route exact path='/accumulate-policy' component={AccumulatePolicy} />}
                {listLink.includes('/accumulate-policy/add') && (<Route path='/accumulate-policy/add' component={AddAccumulatePolicy} />)}
                {listLink.includes('/accumulate-policy/edit') && (<Route path='/accumulate-policy/edit' component={EditAccumulatePolicy} />)}
                {/* Chương trình loyalty */}
                {listLink.includes('/loyalty-program') && <Route exact path='/loyalty-program' component={LoyaltyProgram} />}
                {listLink.includes('/loyalty-program/add') && (<Route path='/loyalty-program/add' component={AddLoyaltyProgram} />)}
                {listLink.includes('/loyalty-program/edit') && (<Route path='/loyalty-program/edit' component={EditLoyaltyProgram} />)}
                {listLink.includes('/point-usage-report') && (
                    <Route path='/point-usage-report' component={PointUsageReport} exact />
                )}
                {listLink.includes('/dashboard-report-loyalty') && (
                    <Route path='/dashboard-report-loyalty' component={DashboardReport} exact />
                )}
                <Route exact path='/'>
                    <Redirect to={listLink[0] || ''} />
                </Route>
                {listLink.length > 0 && <Redirect to='/notFound' />}
            </Switch>
        </Suspense>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.authReducer.detail.token,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveCustomerInfo: (data) => dispatch(saveCustomerInfo(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes);
